<template>

  <div class="search-input-500 d-flex" @click="startSearch">

    <div v-if="!isSearching" class="initial-view">
      <span class="text mx-2 text-muted d-inline">  {{ $t('nav.search_placeholder') }} </span>
      <img class="search-input-500-image" :src="setSearchInputImage"
           :alt="findAttributeOnSiteInfo('site_name')[0]">
    </div>

    <div v-if="isSearching" class="search-bar">
      <input ref="searchInput" @focus="handleFocus()"
             @blur="handleBlur()" type="text" v-model.trim="words"
             class="search-input-500-input border-0 search-input-500-form-absolut-data">
    </div>

  </div>

</template>

<script>
import router from "@/router";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "SearchInput500",
  props: {
    imageInsideSearch: {
      default: ''
    },
  },
  data() {
    return {
      words: '',
      type: 'all',
      isSearching: false,
    }
  },
  computed: {
    setSearchInputImage() {
      if (this.imageInsideSearch.length > 0) {
        return this.imageInsideSearch
      }
      return findAttributeOnSiteInfo('icon')[0]
    }
  },
  methods: {
    findAttributeOnSiteInfo,

    search() {
      router.push({name: 'Search', params: {words: this.words, type: this.type}})
    },
    startSearch() {
      this.isSearching = true; // فعال کردن حالت جستجو
      this.$nextTick(() => {
        // فوکوس روی ورودی پس از رندر مجدد DOM
        const input = this.$refs.searchInput;
        if (input) {
          input.focus();
        }
      });
    },
    handleFocus() {
      // هنگام فوکوس ورودی، اطمینان حاصل می‌کنیم که حالت جستجو فعال است.
      this.isSearching = true;
    },
    handleBlur() {
      // اگر ورودی فوکوس را از دست داد، به حالت اولیه بازگردید.
      if (this.words.length == 0) {
        this.isSearching = false;
      }
    },
  },
}
</script>

<style scoped>
.search-input-500 {
  background: white;
  cursor: text;

}

.search-input-500 .search-input-500-input {
  padding: 5px;
  width: 100%;
  background: transparent;
}

.search-input-500-icon {
  z-index: 100;
  position: relative;
  background-color: transparent;
  padding: 5px 15px 0 0;
}

.search-input-500-form-absolut-data {
  width: 100%;

}

.search-input-500 input::placeholder {
  font-size: 16px;
  text-align: right;
}

.search-input-500 input:focus-visible {
  outline: none;
}

.search-input-500-image {
  height: 36px;

}


</style>